import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackWhatsappClick } from '@/utils/analytics';

export function WhatsAppFloat() {
  const handleWhatsApp = () => {
    trackWhatsappClick('flotante');
    window.open('https://wa.me/+51915976931?text=Hola Huaytanatura, quiero información sobre sus productos naturales y harinas andinas', '_blank');
  };

  return (
    <Button
      onClick={handleWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-primary hover:bg-primary-light text-primary-foreground shadow-natural hover:shadow-elevated transition-all  animate-pulse hover:animate-none hover:scale-110"
      size="sm"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="sr-only">Contactar por WhatsApp</span>
    </Button>
  );
}